import { PlexUserRelationState } from '@all-hands-hq/plex-graphql-schema';
import { Button, Snackbar } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';

import { useSelector } from '../../../redux';
import { useSubscribeToPlex } from './useSnackbarSubscribe';

export function SubscribeSnackbar(): React.ReactElement | null {
  const { setSnackbar, onSubscribeClick, onLeaveClick } = useSubscribeToPlex();
  const { plex, snackbarVisible, isSubscribed } = useSelector((state) => state.notices);
  const isReader = plex?.currentUserRelation.state === PlexUserRelationState.Subscriber;

  if (plex == null) {
    return null;
  }

  const handleConfirmationSnackbarClose = (): void => {
    setSnackbar(plex, false, isSubscribed);
  };
  const handleLeaveClick = async (): Promise<void> => {
    onLeaveClick(plex);
  };
  const handleSubscribeClick = async (): Promise<void> => {
    onSubscribeClick(plex);
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={snackbarVisible}
      autoHideDuration={3000}
      onClose={handleConfirmationSnackbarClose}
      message={isSubscribed ? 'Subscribed' : isReader ? 'Unsubscribed' : 'Left'}
      action={
        isReader ? (
          <React.Fragment>
            <Button color="secondary" size="small" onClick={isSubscribed ? handleLeaveClick : handleSubscribeClick}>
              Undo
            </Button>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleConfirmationSnackbarClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        ) : null
      }
    />
  );
}
